// extracted by css-extract-rspack-plugin
export default {"label":"label--Mjlmj58enwAmgMhh"};